import React, { ReactElement, useContext } from 'react';
import { FormsContext } from 'pages/Forms/context/FormsContext';
import Prompt from '../Prompt';
import { Button, Text } from '@televet/kibble-ui';
import QuestionHeader from '../QuestionHeader';
import RequiredSelector from './RequiredSelector';
import OptionComponent from '../OptionComponent';
import { IFromDraftCommonProps } from '../Question';
import { FormQuestionType } from '@televet/shared-types';

interface IMultipleSelectionProps extends IFromDraftCommonProps {
  options: string[];
  questionType: FormQuestionType;
}

const DropdownOrMultipleSelection = ({
  index,
  prompt,
  options,
  isRequired,
  lastIndex,
  questionType,
}: IMultipleSelectionProps): ReactElement => {
  const { dispatch } = useContext(FormsContext);

  const handleAddOption = (): void => {
    dispatch({
      type: 'ADD_OPTION_AT_INDEX',
      payload: { questionIndex: index },
    });
  };

  return (
    <>
      <QuestionHeader index={index} questionType={questionType} lastIndex={lastIndex} />
      <Prompt index={index} prompt={prompt} />
      {questionType === FormQuestionType.PetPicker ? (
        <Text as="p" variant="subtle" size="sm" my="10px">
          A single-selection drop down pre-populated with the client&apos;s patients.
        </Text>
      ) : (
        <>
          {options.map((option, optionIndex) => {
            return (
              <OptionComponent
                key={`${questionType}-options-${optionIndex}`}
                index={index}
                optionIndex={optionIndex}
                option={option}
                options={options}
              />
            );
          })}
          <Button onClick={handleAddOption}>Add Option</Button>
        </>
      )}
      <RequiredSelector index={index} isRequired={isRequired} />
    </>
  );
};

export default DropdownOrMultipleSelection;
